"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var _AwaitLock_acquired, _AwaitLock_waitingResolvers;

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A mutex lock for coordination across async functions
 */

var AwaitLock = /*#__PURE__*/function () {
  function AwaitLock() {
    _classCallCheck(this, AwaitLock);

    _AwaitLock_acquired.set(this, false);

    _AwaitLock_waitingResolvers.set(this, new Set());
  }
  /**
   * Whether the lock is currently acquired or not. Accessing this property does not affect the
   * status of the lock.
   */


  _createClass(AwaitLock, [{
    key: "acquired",
    get: function get() {
      return __classPrivateFieldGet(this, _AwaitLock_acquired, "f");
    }
    /**
     * Acquires the lock, waiting if necessary for it to become free if it is already locked. The
     * returned promise is fulfilled once the lock is acquired.
     *
     * A timeout (in milliseconds) may be optionally provided. If the lock cannot be acquired before
     * the timeout elapses, the returned promise is rejected with an error. The behavior of invalid
     * timeout values depends on how `setTimeout` handles those values.
     *
     * After acquiring the lock, you **must** call `release` when you are done with it.
     */

  }, {
    key: "acquireAsync",
    value: function acquireAsync() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          timeout = _ref.timeout;

      if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) {
        __classPrivateFieldSet(this, _AwaitLock_acquired, true, "f");

        return Promise.resolve();
      }

      if (timeout == null) {
        return new Promise(function (resolve) {
          __classPrivateFieldGet(_this, _AwaitLock_waitingResolvers, "f").add(resolve);
        });
      }

      var resolver;
      var timer;
      return Promise.race([new Promise(function (resolve) {
        resolver = function resolver() {
          clearTimeout(timer);
          resolve();
        };

        __classPrivateFieldGet(_this, _AwaitLock_waitingResolvers, "f").add(resolver);
      }), new Promise(function (_, reject) {
        timer = setTimeout(function () {
          __classPrivateFieldGet(_this, _AwaitLock_waitingResolvers, "f").delete(resolver);

          reject(new Error("Timed out waiting for lock"));
        }, timeout);
      })]);
    }
    /**
     * Acquires the lock if it is free and otherwise returns immediately without waiting. Returns
     * `true` if the lock was free and is now acquired, and `false` otherwise.
     *
     * This method differs from calling `acquireAsync` with a zero-millisecond timeout in that it runs
     * synchronously without waiting for the JavaScript task queue.
     */

  }, {
    key: "tryAcquire",
    value: function tryAcquire() {
      if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) {
        __classPrivateFieldSet(this, _AwaitLock_acquired, true, "f");

        return true;
      }

      return false;
    }
    /**
     * Releases the lock and gives it to the next waiting acquirer, if there is one. Each acquirer
     * must release the lock exactly once.
     */

  }, {
    key: "release",
    value: function release() {
      if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) {
        throw new Error("Cannot release an unacquired lock");
      }

      if (__classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").size > 0) {
        // Sets preserve insertion order like a queue
        var _classPrivateFieldGe = __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f"),
            _classPrivateFieldGe2 = _slicedToArray(_classPrivateFieldGe, 1),
            resolve = _classPrivateFieldGe2[0];

        __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").delete(resolve);

        resolve();
      } else {
        __classPrivateFieldSet(this, _AwaitLock_acquired, false, "f");
      }
    }
  }]);

  return AwaitLock;
}();

exports.default = AwaitLock;
_AwaitLock_acquired = new WeakMap(), _AwaitLock_waitingResolvers = new WeakMap();